import React from "react";
import MainLayout from "../component/layouts/mainLayout";
import { Route, Routes } from "react-router-dom";
import VOPInfo from "../component/mainPage/vopInfo";
import Reseller from "../component/mainPage/reseller";
import Home from "../component/mainPage/home";
import FacilitiesAndTariffs from "../component/mainPage/facilitiesAndTariffs";
import OptionsIncome from "../component/mainPage/optionsIncome";
import Numbers from "../component/mainPage/numbers";
import ContactUS from "../component/mainPage/contactUS";
const SayyehBan = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        <Route path="/home" element={<Home />} />
        <Route index element={<Home />} />
        <Route
          path="/FacilitiesAndTariffs"
          element={<FacilitiesAndTariffs />}
        />
        <Route path="/VOPInfo" element={<VOPInfo />} />
        <Route path="/Reseller" element={<Reseller />} />
        <Route path="/OptionsIncome" element={<OptionsIncome />} />
        <Route path="/Numbers" element={<Numbers />} />
        <Route path="/ContactUS" element={<ContactUS />} />
      </Route>
    </Routes>
  );
};

export default SayyehBan;
